<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ user.Name }}</h1>
    <br>
    <v-toolbar :color="enterpriseColor" dark>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('users.userTitle') }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <form-user
      :data="user"
      :onDelete="handleDelete"
      :onSave="handleSave"
      :onCancel="handleCancel"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import FormUser from './FormUser'
  export default {
    components: {
      FormUser
    },
    data: () => ({
      user: {},
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      userID () {
        return this.$route.params.id
      },
    },
    watch:{
      $route (to, from){
        if (to.params.id && to.params.id !== from.params.id) {
          if (to.params.id.length > 0) {
            this.handleGetUser()
          }
        }
      }
    },
    mounted () {
      this.handleGetUser()
    },
    methods: {
      handleGetUser () {
        if (this.userID !== 'new') {
          api.getItem('users', true, this.userID).then(response => {
            this.user = {
              Name: response.Name,
              Email: response.Email,
              Role: response.Role,
              Enterprises: response.Enterprises,
              EnterpriseDefault: response.EnterpriseDefault,
              Permission: response.Permission,
              Notification: response.Notification,
              IsShowAllNetworks: response.IsShowAllNetworks,
              Color: response.Color,
              Token: response.Token,
            }
          })
        } else {
          this.user = null
        }
      },
      handleDelete () {
        api.deleteItem('users', this.userID).then(response => {
          if (response.status === 200) this.$router.push('/users')
        })
      },
      handleCancel () {
        this.$router.push('/users')
      },
      handleSave (body) {
        // console.log('body', body)
        if (this.userID === 'new') {
          api.addItem('users', true, body)
            .then(response => {
              // console.log(response)
            })
            .catch(error => {
              // console.log('error', error)
            })
        } else {
          api.updateItem('users', this.userID, body)
            .then(response => {
              // console.log(response)
            })
            .catch(error => {
              // console.log('error', error)
            })
        }
        this.$router.push('/users')
      }
    }
  }
</script>
